/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  PeripheryImmutableState,
  PeripheryImmutableStateInterface,
} from "../../../../../@uniswap/v3-periphery/contracts/base/PeripheryImmutableState";

const _abi = [
  {
    inputs: [],
    name: "WETH9",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "factory",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class PeripheryImmutableState__factory {
  static readonly abi = _abi;
  static createInterface(): PeripheryImmutableStateInterface {
    return new utils.Interface(_abi) as PeripheryImmutableStateInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): PeripheryImmutableState {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as PeripheryImmutableState;
  }
}
